import { useState } from 'react';
export function useEditable(config) {
    const [editableKeys, setEditableKeys] = useState([]);
    console.log('editableKeys', editableKeys);
    const handleEditableKeysChange = (keys) => {
        console.log('keys', keys);
        setEditableKeys(keys);
    };
    return {
        ...config,
        editableKeys,
        onChange: handleEditableKeysChange,
        actionRender: config.actionRender ?? ((row, _, defaultDom) => [defaultDom.save, defaultDom.cancel])
    };
}
